import querystring from 'querystring';
import { pickBy } from 'lodash';

type Params = { [key: string]: any };

const splitUrlPiece = (splitter: string, url = '') => {
  if (url.indexOf(splitter) < 0) {
    url = `${url}${splitter}`;
  }
  const splitterIndex = url.indexOf(splitter);
  return {
    baseHref: url.substring(0, splitterIndex),
    queryString: url.substring(splitterIndex + 1),
  };
};

/**
 * Splits a URL in half by querystring '?'
 */
const splitUrl = splitUrlPiece.bind(null, '?');
const filterEmptyKeys = (obj: Params) => pickBy(obj, (_, key) => !!key);

/**
 * Extracts query params from a URL and returns them as an object.
 *
 * Filters out empty params so the returned object has defined values.
 */
export const extractParams = (url = '') => {
  const params = querystring.parse(splitUrl(url).queryString);
  // Handles a params object that was extracted from an URL with a trailing `&`,
  // which would result in an empty key/value pair.
  return filterEmptyKeys(params);
};
